<template>
  <div>
    <p>AboutMe view !</p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque, aperiam!
      Obcaecati suscipit veritatis voluptatibus expedita necessitatibus nulla
      dignissimos accusantium odio id esse impedit, corrupti doloremque rerum.
      Odit animi sit voluptatibus.
    </p>
  </div>
</template>

<script>
export default {
  name: "AboutMe",
  created() {},
};
</script>
